class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. The morphed children
  // (inserted from the /cart/add.js sections response in renderContents) are
  // post-add, but they don't expose the full cart shape we need for the event
  // payload. So we keep an explicit /cart.json fetch on open. Migrating to the
  // factory + filter would require re-rendering the notification element
  // itself in sections, which is out of scope for this PR.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    /* --- INIZIO MODIFICA: AGGIORNAMENTO DINAMICO SPEDIZIONE --- */
    if (parsedState) {
      this.updateFreeShipping();
    }
    /* --- FINE MODIFICA --- */

    if (this.header) this.header.reveal();
    this.open();
  }

  /* --- LOGICA CALCOLO SPEDIZIONE CON TRADUZIONI --- */
 updateFreeShipping() {
    const container = document.getElementById('free-shipping-popup-final-container');
    const textTarget = document.getElementById('free-shipping-popup-final-text');
    const noteTarget = document.getElementById('free-shipping-popup-exclusion-note');
    const config = window.theme?.shipping;
    const threshold = window.theme?.freeShippingThreshold;

    if (!container || !textTarget || !config || !threshold) return;

    fetch(`${window.Shopify.routes.root}cart.js?v=${new Date().getTime()}`, { cache: 'no-store' })
      .then(res => res.json())
      .then(async (cart) => {
        let eligibleTotal = cart.total_price;

        const remaining = threshold - eligibleTotal;
        container.style.display = 'block';

        if (remaining > 0) {
          const money = new Intl.NumberFormat(window.Shopify.locale === 'it' ? 'it-IT' : 'en-GB', { 
            style: 'currency', 
            currency: cart.currency 
          }).format(remaining / 100);
          
          textTarget.innerHTML = config.missing.replace('[amount]', `<span style="color: #ff0000;">${money}</span>`);
          
          // MOSTRA LA NOTA SE MANCA QUALCOSA
          if (noteTarget) {
            noteTarget.innerHTML = config.exclusionNote;
            noteTarget.style.display = 'block';
          }
        } else {
          textTarget.innerHTML = `<span style="color: #2d8a28;">${config.reached}</span>`;
          


          // MOSTRA LA NOTA SE LA SOGLIA È RAGGIUNTA
          if (noteTarget) noteTarget.style.display = 'none';
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-notification-cross-sell',
        selector: `[id="cart-notification-cross-sell-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);